export default __webpack_public_path__ + "static/img/vogue_scene_animated_0071.5fc31bd.jpg";